import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { useMutation, useQuery } from "react-query";

// components
import { UniversalURLLoader } from "components/Loader/UniversalURL";
import { UniversalURLMainErrorScreen } from "components/UniversalURL/UniversalURLMainErrorScreen";

// helpers
import { axiosInstance, goAxiosInstance } from "helpers/axiosInstance";
import { ThemeContext } from "components/ListingNew/ListingTheme";
import { UserContext } from "store";

export const ListingInterface = createContext(null);

export const ListingData = ({ children, id }) => {
	// query parametrs
	const useSearchQuery = () => {
		const { search } = useLocation();
		return useMemo(() => new URLSearchParams(search), [search]);
	};

	let query = useSearchQuery();

	const [searchParams, setSearchParams] = useSearchParams();
	const {
		state: { currentUser },
	} = useContext(UserContext);

	const newListingArray = window.location.pathname
		.split("/")
		[window.location.pathname.split("/").length - 1].split("-");
	const newListingId = newListingArray[newListingArray.length - 1];

	// const [delistedLoading, setDelistedLoading] = useState(false);

	//---URL
	const listingURL = "https://go.saffronstays.com/api/listing";

	const { dispatch } = useContext(ThemeContext);

	//---query
	const listingData = useQuery(
		"listing",
		() =>
			localStorage.getItem("token")
				? goAxiosInstance({
						method: "GET",
						url: `${listingURL}?id=${newListingId || id}`,
						headers: {
							Authorization: `Bearer ${localStorage.getItem("token")}`,
						},
				  })
				: goAxiosInstance({
						method: "GET",
						url: `${listingURL}?id=${newListingId || id}`,
				  }),
		{
			onSuccess: ({ data: { data } }) => {
				if (
					data.listing_list.signature &&
					data.listing_list.signature === "X-Series" &&
					!currentUser?.email?.includes("@saffronstays.com")
				) {
					dispatch({ type: "SET_THEME", payload: data.listing_list.signature });
				}
				if (
					data.listing_list.signature &&
					data.listing_list.signature === "NEXT" &&
					!currentUser?.email?.includes("@saffronstays.com")
				) {
					dispatch({ type: "SET_THEME", payload: "NEXT" });
				}
			},
		},
	);

	// useEffect(() => {
	// 	listingData.refetch();
	// }, []);

	useEffect(() => {
		if (
			currentUser?.email &&
			currentUser?.email?.includes("@saffronstays.com")
		) {
			dispatch({ type: "SET_THEME", payload: "" });
		}
	}, [currentUser]);

	// const getRecommToRedirect = useMutation(
	// 	["getRecommToRedirect"],
	// 	() => {
	// 		return axiosInstance({
	// 			method: "POST",
	// 			url: `https://ecapi.saffronstays.com/user/interactions/itemrecommendation`,
	// 			data: {
	// 				// userId:
	// 				// 	localStorage.getItem("uuid") ||
	// 				// 	localStorage.getItem("guestUniqueId"),
	// 				itemId: newListingId || id,
	// 				scenario: "crm",
	// 				filter: "\"7\" == 'num_similar_rooms'",
	// 				count: 2,
	// 			},
	// 		});
	// 	},
	// 	{
	// 		onSuccess: (data) => {
	// 			// Redirect to another similar listing
	// 			const redirectURL = `/view/${data?.data?.data?.listingdata[1].seoURL}-${data?.data?.data?.listingdata[1].id}`;
	// 			window.location.pathname = redirectURL;
	// 		},
	// 		cacheTime: 0,
	// 	},
	// );

	// useViewInteraction function sends data to recombee
	const useViewInteraction = useMutation(() => {
		return axiosInstance({
			method: "POST",
			url: "/user/interactions/view",
			data: {
				userId:
					localStorage.getItem("uuid") || localStorage.getItem("guestUniqueId"),
				itemId: newListingId || id,
			},
			headers: {
				Authorization: `Bearer ${localStorage.getItem("token")}`,
			},
		});
	});

	const { data: resposeData, isLoading, isError } = listingData;
	const data = resposeData?.data;
	const listingList = data?.data?.listing_list;
	const amen_list = data?.data?.amenities_list;

	const [roomsData, setRoomsData] = useState(Number(query.get("rooms")) || 0);
	const [adultsData, setAdultsData] = useState(
		Number(query.get("adults")) || 0,
	);
	const [childrenData, setChildrenData] = useState(
		Number(query.get("children")) || 0,
	);
	const [infantsData, setInfantsData] = useState(
		Number(query.get("infants")) || 0,
	);
	const [petData, setPetData] = useState(Number(query.get("pets")) || 0);
	const [showPet, setShowPet] = useState(false);
	const [petCharge, setPetCharge] = useState(0);

	useEffect(() => {
		if (
			Object.keys(amen_list || []).includes("14") ||
			Object.keys(amen_list || []).includes("19")
		) {
			setShowPet(true);
			setPetCharge(listingList?.pet_charges);
		}
	}, [amen_list]);

	useEffect(() => {
		if (
			listingList?.min_rooms &&
			(adultsData === 0 || isNaN(adultsData) === true)
		) {
			setRoomsData(listingList?.min_rooms);
		}
	}, [adultsData, listingList?.min_rooms]);

	useEffect(() => {
		if (
			(listingList?.TYPE_FLAG === "MR" || listingList?.TYPE_FLAG === "EV-MR") &&
			roomsData > listingList?.num_similar_rooms
		) {
			searchParams.set("rooms", listingList?.min_rooms);
			setSearchParams(searchParams, { replace: true });
			setRoomsData(listingList?.min_rooms);
		}
	}, [
		listingList?.min_rooms,
		listingList?.TYPE_FLAG,
		listingList?.num_similar_rooms,
		roomsData,
		searchParams,
		setSearchParams,
	]);

	useEffect(() => {
		if (
			listingList?.TYPE_FLAG === "MR" &&
			roomsData > listingList?.num_similar_rooms
		) {
			searchParams.set("rooms", listingList?.min_rooms);
			setSearchParams(searchParams, { replace: true });
			setRoomsData(listingList?.min_rooms);
		}
	}, [
		listingList?.min_rooms,
		listingList?.num_similar_rooms,
		listingList?.TYPE_FLAG,
		roomsData,
		searchParams,
		setSearchParams,
	]);

	useEffect(() => {
		if (
			listingList?.TYPE_FLAG === "SR" &&
			roomsData > listingList?.num_similar_rooms
		) {
			setRoomsData(listingList?.min_rooms);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [roomsData, listingList?.min_rooms]);

	useEffect(() => {
		if (
			listingList?.TYPE_FLAG === "EV" &&
			(roomsData > listingList?.min_rooms || roomsData < listingList?.min_rooms)
		) {
			setRoomsData(listingList?.min_rooms);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [roomsData, listingList?.min_rooms]);

	useEffect(() => {
		if (
			(listingList?.TYPE_FLAG === "EV" || listingList?.TYPE_FLAG === "EV-MR") &&
			(adultsData === 0 || isNaN(adultsData) === true)
		) {
			setAdultsData(listingList?.min_rooms * listingList?.capacity);
		}
	}, [
		adultsData,
		listingList?.capacity,
		listingList?.min_rooms,
		listingList?.TYPE_FLAG,
		roomsData,
	]);

	useEffect(() => {
		if (
			listingList?.TYPE_FLAG === "EV" &&
			(adultsData > listingList?.max_capacity ||
				roomsData > listingList?.min_rooms ||
				adultsData + childrenData > listingList?.max_capacity ||
				infantsData > 10)
		) {
			setAdultsData(listingList?.capacity);
			setChildrenData(0);
			setInfantsData(0);
			setRoomsData(listingList?.min_rooms);
			searchParams.set("children", "");
			searchParams.set("infants", "");
			searchParams.set("rooms", listingList?.min_rooms);
			setSearchParams(searchParams, { replace: true });
		}
	}, [
		adultsData,
		childrenData,
		infantsData,
		listingList?.capacity,
		listingList?.max_capacity,
		listingList?.min_rooms,
		listingList?.TYPE_FLAG,
		roomsData,
		searchParams,
		setSearchParams,
	]);

	useEffect(() => {
		if (
			listingList?.TYPE_FLAG !== "EV" &&
			listingList?.TYPE_FLAG !== "EV-MR" &&
			(adultsData === 0 || isNaN(adultsData) === true)
		) {
			setAdultsData(listingList?.capacity * roomsData);
		}
	}, [adultsData, listingList?.capacity, listingList?.TYPE_FLAG, roomsData]);

	useEffect(() => {
		if (
			listingList?.TYPE_FLAG === "MV" &&
			roomsData <= +listingList?.num_similar_rooms - 1 &&
			adultsData + childrenData >
				(listingList?.max_capacity / listingList?.num_similar_rooms) * roomsData
		) {
			setAdultsData(
				(listingList?.max_capacity / listingList?.num_similar_rooms) *
					roomsData,
			);
			searchParams.set(
				"adults",
				(listingList?.max_capacity / listingList?.num_similar_rooms) *
					roomsData,
			);
			searchParams.set("children", "");
			setSearchParams(searchParams, { replace: true });

			setChildrenData(0);
		}
	}, [
		adultsData,
		childrenData,
		listingList?.max_capacity,
		listingList?.num_similar_rooms,
		listingList?.TYPE_FLAG,
		roomsData,
		searchParams,
		setSearchParams,
	]);

	useEffect(() => {
		if (
			listingList?.TYPE_FLAG === "EV-MR" &&
			roomsData <= +listingList?.num_similar_rooms - 1 &&
			adultsData + childrenData >
				Math.round(listingList?.max_capacity / listingList?.num_similar_rooms) *
					roomsData
		) {
			setAdultsData(
				Math.round(listingList?.max_capacity / listingList?.num_similar_rooms) *
					roomsData,
			);
			searchParams.set(
				"adults",
				Math.round(listingList?.max_capacity / listingList?.num_similar_rooms) *
					roomsData,
			);
			searchParams.set("children", "");
			setSearchParams(searchParams, { replace: true });
			setChildrenData(0);
		}
	}, [
		adultsData,
		childrenData,
		listingList?.max_capacity,
		listingList?.num_similar_rooms,
		listingList?.TYPE_FLAG,
		roomsData,
		searchParams,
		setSearchParams,
	]);

	useEffect(() => {
		if (
			listingList?.TYPE_FLAG === "MR" &&
			roomsData <= +listingList?.num_similar_rooms - 1 &&
			adultsData + childrenData >
				Math.round(listingList?.max_capacity / listingList?.num_similar_rooms) *
					roomsData
		) {
			setAdultsData(
				Math.round(
					(listingList?.max_capacity / listingList?.num_similar_rooms) *
						roomsData,
				),
			);
			searchParams.set(
				"adults",
				Math.round(
					(listingList?.max_capacity / listingList?.num_similar_rooms) *
						roomsData,
				),
			);
			searchParams.set("children", "");
			setSearchParams(searchParams, { replace: true });
			setChildrenData(0);
		}
	}, [
		adultsData,
		childrenData,
		listingList?.max_capacity,
		listingList?.num_similar_rooms,
		listingList?.TYPE_FLAG,
		roomsData,
		searchParams,
		setSearchParams,
	]);

	useEffect(() => {
		listingData.refetch();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [infantsData, childrenData, adultsData, roomsData]);

	const [highlight, setHighlight] = useState(false);

	const [isFromGoogle, setIsFromGoogle] = useState(false);
	useEffect(() => {
		if (searchParams?.get("source") === "google") setIsFromGoogle(true);
	}, [searchParams]);

	//---value
	const value = {
		id,
		newListingId,
		data,
		query,
		isLoading,
		isError,
		infantsData,
		childrenData,
		adultsData,
		roomsData,
		listingList,
		setAdultsData,
		setChildrenData,
		setInfantsData,
		setRoomsData,
		useViewInteraction,
		highlight,
		setHighlight,
		showPet,
		isFromGoogle,
	};

	if (showPet) {
		value.setPetData = setPetData;
		value.petData = petData;
		value.petCharge = petCharge;
	}

	const renderListingPage = () => {
		// if (isLoading || delistedLoading) {
		if (isLoading) {
			return <UniversalURLLoader />;
		} else if (isError && !isLoading) {
			return <UniversalURLMainErrorScreen />;
		} else {
			return (
				<ListingInterface.Provider value={value}>
					{children}
				</ListingInterface.Provider>
			);
		}
	};

	return <>{renderListingPage()}</>;
};
